module.exports = __webpack_public_path__ + "static/img/main_logo.1e34836.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cereshop/home/main_logo.png
// module id = yy6E
// module chunks = 18